// extracted by mini-css-extract-plugin
export var header = "code-block-header-module--header--2Vy5w";
export var headerDot = "code-block-header-module--headerDot--2qNtU";
export var headerText = "code-block-header-module--headerText--3YUga";